import type { RegistryEntry, UiOptionSelect } from '../types';
import { clampTo } from '../../tools';

const MAI_OUTPUT_FORMAT_OPTION = {
  key: 'output_format',
  label: 'Output Format',
  type: 'select',
  options: [
    { label: 'PNG', value: 'png' },
    { label: 'JPEG', value: 'jpeg' },
    { label: 'WebP', value: 'webp' },
  ],
  default: 'png',
  group: 'basic',
} as UiOptionSelect;

const toMaiProviderOptions = (ui: Record<string, any>) =>
  ({
    output_format: clampTo(
      ui.output_format || 'png',
      ['png', 'jpeg', 'webp'] as const,
      'png',
    ),
  }) as unknown as Record<string, Record<string, any>>;

const maiImageEntry: RegistryEntry = {
  options: [MAI_OUTPUT_FORMAT_OPTION],
  toProviderOptions: toMaiProviderOptions,
};

export const microsoftConfigs: Record<string, RegistryEntry> = {
  'mai-image-2.5': maiImageEntry,
};